import { withStyles } from '@material-ui/styles';
import TableCell from '@material-ui/core/TableCell';

const TableCellHeaderGestion = withStyles(() => ({
  head: {
    color: '#3c5992',
    background: '#deebf4',
  },
  body: {
    fontSize: 14,
    fontWeight: 'bold',
  },
}))(TableCell);

export default TableCellHeaderGestion;
